<template>
  <div>
    <v-container class="pa-0" fluid>
      <v-row style="height: 48px; max-height: 48px">
        <ContenidoBase
          :EstadoBtn="EstadoBtn"
          :descripcion="'Imprime las Ventas de articulos'"
          :show-absolute="false"
          :titulo="'Venta por Articulos'"
        />
      </v-row>

      <v-row>
        <!-- Contenido central ------------------------------------------------------------------------------ -->
        <v-col :max-height="this.windowSize.height - 96">
          <v-app
            id="inspire"
            class="overflow-y-auto"
            v-bind:style="{ 'max-height': this.windowSize.height - 96 + 'px' }"
          >
            <!--- Formulario --->
            <v-container>
              <v-card color="grey lighten-3">
                <v-toolbar color="#BDBDBD" dense flat style="border: 1px solid #000000">
                  <v-avatar size="45" tile>
                    <img alt="Reporte" src="@/assets/iconos_micromarket/custom-reports.png" />
                  </v-avatar>
                  <span class="font-weight-light" style="font-size: 20px">Venta por Articulos</span>
                </v-toolbar>

                <hr />

                <v-container style="border: 1px solid #000000">
                  <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="">
                    <v-row>
                      <!--- Columna 1 --->
                      <v-col cols="12" md="6" sm="6">
                        <!--- Desde  --->
                        <v-text-field
                          v-model="datos.desde"
                          :rules="[$rules.required]"
                          dense
                          label="Desde:"
                          outlined
                          type="date"
                        >
                          <template v-slot:prepend>
                            <i class="fa fa-calendar" style="font-size: 20px"></i>
                          </template>
                        </v-text-field>

                        <!--- Fabricante --->
                        <v-autocomplete
                          v-model="datos.fabricante"
                          :items="fabricanteList"
                          :search-input.sync="searchFabricante"
                          clearable
                          dense
                          item-text="nombre"
                          label="Fabricante"
                          no-filter
                          outlined
                          return-object
                          @focus.once="findFabricante"
                        >
                          <template v-slot:prepend>
                            <i class="fa fa-industry" style="font-size: 20px; width: 1.3rem"></i>
                          </template>
                        </v-autocomplete>

                        <!--- Proveedor --->
                        <v-autocomplete
                          v-if="false"
                          v-model="datos.proveedor"
                          :items="proveedorList"
                          :search-input.sync="searchProveedor"
                          clearable
                          dense
                          item-text="nombre"
                          label="Proveedor"
                          no-filter
                          outlined
                          return-object
                          @focus.once="findProveedor"
                        >
                          <template v-slot:prepend>
                            <i class="fa fa-user" style="font-size: 20px; width: 1.3rem"></i>
                          </template>
                        </v-autocomplete>
                      </v-col>
                      <!--- Fin Columna 1 --->

                      <!--- Columna 2 --->
                      <v-col cols="12" md="6" sm="6">
                        <!--- Hasta --->
                        <v-text-field
                          v-model="datos.hasta"
                          :rules="[$rules.required]"
                          dense
                          label="Hasta:"
                          outlined
                          type="date"
                        >
                          <template v-slot:prepend>
                            <i class="fa fa-calendar" style="font-size: 20px"></i>
                          </template>
                        </v-text-field>

                        <!--- Vendedor  --->
                        <v-autocomplete
                          v-model="datos.vendedor"
                          :items="vendedorList"
                          :search-input.sync="searchVendedor"
                          clearable
                          dense
                          item-text="nombre"
                          label="Vendedor"
                          outlined
                          return-object
                          @focus.once="findVendedor"
                        >
                          <template v-slot:prepend>
                            <i class="fa fa-user-circle-o" style="font-size: 20px; width: 1.3rem"></i>
                          </template>
                        </v-autocomplete>

                        <div class="pl-8">
                          <v-switch v-model="datos.showUnificado" class="mt-0" color="teal" hide-details inset>
                            <template v-slot:label>
                              <strong style="color: #000000">Unificado: {{ datos.showUnificado ? "Si" : "No" }}</strong>
                            </template>
                          </v-switch>

                          <v-switch v-model="datos.showVentaDeOfertas" class="mt-2" color="teal" hide-details inset>
                            <template v-slot:label>
                              <strong style="color: #000000">
                                Venta de ofertas: {{ datos.showVentaDeOfertas ? "Si" : "No" }}
                              </strong>
                            </template>
                          </v-switch>
                        </div>
                      </v-col>
                      <!--- Fin Columna 1 --->
                    </v-row>
                  </v-form>
                </v-container>

                <hr />
                <ModalReporteFiltros :Datos="datos" @DataReporteBasico="DDataReporteBasico" />
              </v-card>
            </v-container>
            <!-- fn Formulario-Venta por Articulos -->
          </v-app>
        </v-col>
        <!-- fn contenido central ------------------------------------------------------------------------------------->
      </v-row>
    </v-container>

    <!-- Modales -------------------------------------------------------------------------------------------------->

    <v-snackbar
      v-model="aalert.estado"
      :color="aalert.color"
      :timeout="120000"
      :vertical="true"
      style="margin-top: 20%"
      top="top"
    >
      {{ aalert.nombre }}
      <v-btn dark text @click="aalert.estado = false">Close</v-btn>
    </v-snackbar>

    <!-- fn Modales ----------------------------------------------------------------------------------------------->
  </div>
</template>

<script>
  import { EventBus } from "../../event-bus"
  import BarraBusqueda2 from "../../components/BarraBusquedaDinam"
  import ContenidoBase from "../../components/ContenidoBase"
  import ModalReporteFiltros from "../../components/ModalReporteFiltros2"
  import {
    fechaNueva,
    FormatoFecha,
    getParamFecha,
    HoraFormatter,
    HoraFormatter2,
    RedondeoBasico,
    RedondeoValor,
    RedondeoValorCantRed,
  } from "@/js/Funciones.js"

  export default {
    components: {
      BarraBusqueda2,
      ContenidoBase,
      ModalReporteFiltros,
    },

    created() {
      var json = {
        titulo: "Resumen de Venta por Articulos",
        descripcion: "Imprime las Ventas Generadas por Articulos",
        save: false,
        eliminar: false,
        anular: false,
        nuevo: false,
        imprimir: false,
        accion: [
          "ReportesVentaArticulosNew",
          "ReportesVentaArticulosSave",
          "ReportesVentaArticulosRemove",
          "ReportesVentaArticulosAnular",
          "ReportesVentaArticulosPrintList",
        ],
      }
      EventBus.$emit("anularBotonesAccion", json)
    },

    mounted() {
      EventBus.$on("abrirMenuizquierdo", this.abrirTabla)
      // EventBus.$on("abrirMenuizquierdo", this.abrirTabla2);
      EventBus.$on("ReportesVentaArticulosNew", this.new)
      EventBus.$on("ReportesVentaArticulosSave", this.save)
      EventBus.$on("ReportesVentaArticulosRemove", this.remove)
      EventBus.$on("ReportesVentaArticulosAnular", this.remove)
      EventBus.$on("ReportesVentaArticulosPrintList", this.imprimirList)
      EventBus.$on("emitReportesVentaArticulos", this.datostabla)
      EventBus.$on("onResize", this.onResize)
    },

    data: () => ({
      windowSize: { width: "auto", height: "auto" },

      datos: {
        UrlImprimir: "/reportes-pv/imprimirVentaDeArticulos",
        UrlExel: "/reportes-pv/excelVentaDeArticulos",
        UrlCorreo: "/reportes-pv/",
        desde: fechaNueva(),
        hasta: fechaNueva(),
        fabricante: null,
        vendedor: null,
        proveedor: null,
        showVentaDeOfertas: false,
        showUnificado: false,
        nombre: "VENTAS POR ARTICULOS",
      },

      fabricanteList: [],
      searchFabricante: "",
      proveedorList: [],
      searchProveedor: "",

      vendedorList: [],
      searchVendedor: "",

      EstadoBtn: {
        BarraTablaDinamicaAprir: false,
        nuevo: false,
        guardar: false,
        eliminar: false,
        anular: false,
        imprimir: false,
        vercuenta: false,
        guardartemporal: false,
        restaurartemporal: false,
        importarDato: false,
        cargarProducto: false,
        ImprimirproductoInv: false,
      },

      valid: true,

      aalert: {
        estado: false,
        color: null,
      },
    }),

    methods: {
      FormatoFecha,
      HoraFormatter,
      HoraFormatter2,
      RedondeoValor,
      RedondeoBasico,
      RedondeoValorCantRed,
      fechaNueva,
      getParamFecha,

      onResize(e) {
        this.windowSize = e
      },

      save() {},
      remove() {},
      imprimirList() {},

      alerta(e, l) {
        if (l == "bien") {
          this.aalert.estado = true
          this.aalert.color = "success"
          this.aalert.nombre = e
        }

        if (l == "error") {
          this.aalert.estado = true
          this.aalert.color = "error"
          this.aalert.nombre = e
          this.ejecucion = false
        }
      },

      //Retorna los datos del componente modalreporte
      DDataReporteBasico() {},

      // Buscar fabricante
      findFabricante() {
        this.$axios
          .get(this.$hostname + this.$hName + "/fabricante/findAll", {
            headers: this.$store.getters.GetheadersAxios,
            params: {
              nombre: this.searchFabricante,
            },
          })
          .then((res) => {
            this.fabricanteList = res.data.content
          })
          .catch((err) => {
            console.error(err)
          })
      },

      // Buscar proveedor
      findProveedor() {
        let nombre = this.searchProveedor || "a"

        this.$axios
          .get(this.$hostname + this.$hName + "/proveedores/findallbyDesc/10/0/" + nombre, {
            headers: this.$store.getters.GetheadersAxios,
          })
          .then((res) => {
            this.proveedorList = res.data
          })
          .catch((err) => {
            console.error(err)
          })
      },

      // Buscar vendedor
      findVendedor() {
        this.$axios
          .get(this.$hostname + this.$hName + "/vendedores/findAllByNombre", {
            headers: this.$store.getters.GetheadersAxios,
            params: {
              nombre: this.searchVendedor,
            },
          })
          .then((res) => {
            this.vendedorList = res.data.content
          })
          .catch((err) => {
            console.error(err)
          })
      },
    },

    watch: {
      searchFabricante() {
        this.findFabricante()
      },

      searchVendedor() {
        this.findVendedor()
      },

      searchProveedor() {
        this.findProveedor()
      },

      "datos.showUnificado"(val) {
        if (this.datos.showVentaDeOfertas && this.datos.showUnificado) {
          this.datos.showVentaDeOfertas = false
        }
      },

      "datos.showVentaDeOfertas"(val) {
        if (this.datos.showVentaDeOfertas && this.datos.showUnificado) {
          this.datos.showUnificado = false
        }
      },
    },
  }
</script>

<style></style>
